<template src="./DashboardClinic.html" lang="html"></template>

<script>
import mixins from "../../../../Mixins.js";
import ECharts from "vue-echarts/components/ECharts";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import "echarts/lib/chart/pie";
export default {
  mixins: [mixins],
    components: {
    ECharts
  },
  data() {
    return {
      confirmed: 0,
      concluded: 0,
      waitingMatch: 0,
      waitingAprove: 0,
      patients : 0,
      appointments: [],
      netBalance: 0,
       pie: {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          left: "left",
          data: [
            "Solicitações pendentes",
            "Consultas agendadas",
            "Consultas finalizadas",
            "Consultas pendentes",
            "Pacientes atendidos"
          ]
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: "55%",
            center: ["50%", "60%"],
            color: ["#FF0000", "#508cc8", "#3c6997", "#78c8be", "#fd7e14"],
            data: [
              { value: 0, name: "Solicitações pendentes" },
              { value: 0, name: "Consultas agendadas" },
              { value: 0, name: "Consultas finalizadas" },
              { value: 0, name: "Consultas pendentes" },
              { value: 0, name: "Pacientes atendidos" }
            ],
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      }
    }
  },
  mounted: function() {
    const vm = this;
    vm.init();
  },
  methods: {
    init() {
      const vm = this;
      vm.getAppointmentsSummary();
      vm.getScheduleWaitingMatch();
      vm.getScheduleWaitingAprove();
    },
     getAppointmentsSummary() {
    const vm = this;
    
    vm.axios.get(`${vm.$store.state.filooServer}webclinics/appointments/clinic-summary`, {
      headers: { Authorization: vm.$session.get("bearer") }
    }).then(response => {
      if (response.status === 200) {
        vm.confirmed = response.data.confirmed;
        vm.concluded = response.data.concluded;
        vm.patients = response.data.patientsSeen;
        vm.updateChart();
      }
    }).catch(error => {
      console.error('Error fetching appointments summary:', error);
    });
  },
    getScheduleWaitingMatch() {
      const vm = this;
      const filter = ["WAITING_MATCH"]
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "webclinics/schedules?status=" + filter + "&page=0&size=1&sort=id,desc",
          {
            headers: { Authorization: vm.$session.get("bearer") }
          }
        )
        .then(function(response) {
          if (response.status === 200) {
            vm.waitingMatch = response.data.totalElements;
            vm.updateChart();
          }
        });
    },
    getScheduleWaitingAprove() {
      const vm = this;
      const filter = ["WAITING_APPROVE"]
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "webclinics/schedules?status=" + filter + "&page=0&size=1&sort=id,desc",
          {
            headers: { Authorization: vm.$session.get("bearer") }
          }
        )
        .then(function(response) {
          if (response.status === 200) {
            vm.waitingAprove = response.data.totalElements;
            vm.updateChart();
          }
        });
    },
    updateChart() {
      const vm = this;
      vm.pie.series[0].data = [
        { value: vm.waitingAprove, name: "Solicitações pendentes" },
        { value: vm.confirmed, name: "Consultas agendadas" },
        { value: vm.concluded, name: "Consultas finalizadas" },
        { value: vm.waitingMatch, name: "Consultas pendentes" },
        { value: vm.patients, name: "Pacientes atendidos" }
      ];
    }
  }
};
</script>

<style src="./DashboardClinic.scss" lang="scss">
</style>